// import PersonalsList from './entities/personals-list';
import PersonalEmailChange from './entities/personal-email-change';
import PersonalEmailVerify from './entities/personal-email-verify';
import PersonalProfile from './entities/personal-profile';
import PersonalPassword from './entities/personal-password';
// import PersonalPrograms from './entities/personal-programs';
import PersonalLifeStages from './entities/personal-life-stages';
import PersonalBiography from './entities/personal-biography';
import PersonalBiographyEducation from './entities/personal-biography-education';
import PersonalBiographyExperience from './entities/personal-biography-experience';
// import PersonalMeasurement from './entities/personal-measurement';
// import PersonalMeasurements from './entities/personal-measurements';
// import PersonalAssignProgram from './entities/personal-assign-program';
// import PersonalCreateProgram from './entities/personal-create-program';
// import PersonalHealthCategory from './entities/personal-health-category';
// import PersonalSettingsMeasurementsGeneral from './entities/personal-settings-measurements-general';
// import PersonalSettingsTrackedMeasurements from './entities/personal-settings-tracked-measurements';
// import PersonalSemanticKeyWordOperationsSelected from './entities/personal-semantic-key-word-operations-selected';

import PersonalSchedules from './entities/personal-schedules';
import PersonalScheduleDetails from './entities/personal-schedule-details';

import PersonalScheduledDates from './entities/personal-scheduled-dates';
import PersonalScheduledDateSchedules from './entities/personal-scheduled-date-schedules';

import PersonalRoles from './entities/personal-roles';
import PersonalStatistics from './entities/personal-statistics';

import PersonalEmailResendVerfication from './entities/personal-email-resend-verfication';

export default {
  modules: {
    // PersonalsList,
    PersonalEmailChange,
    PersonalEmailVerify,
    PersonalProfile,
    PersonalPassword,
    // PersonalPrograms,
    PersonalLifeStages,
    PersonalBiography,
    PersonalBiographyEducation,
    PersonalBiographyExperience,
    PersonalSchedules,
    PersonalScheduleDetails,
    PersonalScheduledDates,
    PersonalScheduledDateSchedules,
    // PersonalMeasurement,
    // PersonalMeasurements,
    // PersonalAssignProgram,
    // PersonalCreateProgram,
    // PersonalHealthCategory,
    // PersonalSettingsMeasurementsGeneral,
    // PersonalSettingsTrackedMeasurements,
    // PersonalSemanticKeyWordOperationsSelected,
    PersonalRoles,
    PersonalStatistics,
    PersonalEmailResendVerfication,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/personal/index.js